<template>
  <div>
    <transition name="fade" mode="out-in">
      <div class="table_search table_search-senior pat20" v-if="AdvancedShow">
        <!-- 日期 -->
        <div class="table_search_item" v-if="isInterviewType">
          <el-date-picker
            v-model="search.contractBeginTime"
            type="date"
            placeholder="合同起始日期"
            value-format="yyyy-MM-dd"
            class="search_item_date"
            @change="hanldeClickDate1"
          ></el-date-picker>
          <span class="search_item_to">至</span>
          <el-date-picker
            v-model="search.contractEndTime"
            type="date"
            placeholder="合同结束日期"
            class="search_item_date"
            value-format="yyyy-MM-dd"
            @change="hanldeClickDate2"
          ></el-date-picker>
        </div>
        <!-- 银行卡号 -->
        <div class="table_search_item" v-if="isInterviewType">
          <el-input v-model="search.cardNum" placeholder="银行卡号"></el-input>
        </div>
        <!-- 身高 -->
        <div class="table_search_item table_search_height">
          <el-input v-model="search.height" placeholder="身高" class="w100 height_input"></el-input>
          <span>cm</span>
        </div>
        <!-- 籍贯/户口所在地/居住地址 -->
        <div class="table_search_item">
          <el-input v-model="search.nativePlace" placeholder="籍贯/户口所在地/居住地址"></el-input>
        </div>
        <!-- 出生日期 -->
        <div class="table_search_item">
          <el-date-picker v-model="search.birthday" type="date" placeholder="出生日期" class="search_item_date"></el-date-picker>
        </div>
      </div>
    </transition>
    <!-- 搜索的一部分 -->
    <div class="table_search">
      <!-- 工号姓名 -->
      <div class="table_search_item">
        <el-input v-model="search.name" placeholder="姓名" @keyup.enter.native="handleSearch"></el-input>
      </div>
      <!-- 身份证号码 -->
      <div class="table_search_item">
        <el-input v-model="search.idNum" placeholder="身份证号码" @keyup.enter.native="handleSearch"></el-input>
      </div>
      <!-- 手机号码 -->
      <div class="table_search_item">
        <el-input v-model="search.phone" placeholder="手机号码" @keyup.enter.native="handleSearch"></el-input>
      </div>
      <!-- 项目名称 -->
      <!-- <div class="table_search_item">
        <el-input v-model="search.projectName" placeholder="项目名称" v-if="isProjectShow"></el-input>
      </div> -->
      <!-- 搜索 -->
      <div class="table_search_item table_search_search">
        <el-button type="primary" icon="el-icon-search" class="table_search_search_btn" @click.native="handleSearch" size="small" >搜索</el-button>
      </div>
      <!-- 高级搜索 -->
      <div class="table_search_item" v-if="isAdvancedSearch">
        <el-button type="text" @click="hadleSHowGoSearch">
          高级搜索
          <i :class="['el-icon-d-arrow-left',AdvancedShow?'rotate_top':'rotate_bottom']"></i>
        </el-button>
      </div>
    </div>
    <!-- 分类选择内容 -->
    <div :class="['table_search_class','clearfix',isAuditedType? 'table_audited_class':'table_tobe_audited_class']" v-if="ClassSelect.length > 0">
      <div class="left class_type">
        <class-select
          @selectValue="selectValue"
          v-for="(item,index) in ClassSelect"
          :placeholder="item.company.placeholder"
          :type="item.company.type"
          :options="item.company.list"
          :key="index"
        ></class-select>
      </div>
      <div  class="right chekboxGroup" >
        <el-checkbox-group v-model="checkedCards" >
          <el-checkbox v-for="(card,index) in cards" :label="card" :key="index" @change="handleClickCheck(card)">{{card.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      </div>
  </div>
</template>

<script>
import ClassSelect from "./../ClassSelect";

export default {
  name: "TableHeader",
  props: {
    cards: { //  各个证件
      type: Array,
      default: ()=>[]
    },
    ClassSelect: { // 下拉搜索
      type: Array,
      default: ()=>[]
    },
    isAuditedType:{ // 当前状态 -  针对人员列表
      type:Boolean
    },
    isInterviewType:{ //  当前状态 -  针对面试人员
      type:Boolean,
      default: true
    },
    isAdvancedSearch:{ // 高级功能是否显示
      type:Boolean,
      default: false
    },
    isProjectShow:{  // 项目是否显示项目查询
      type:Boolean,
      default: false
    } 
  },
  components: { ClassSelect },
  data() {
    return {
      checkedCards: [],
      // 高级搜索
      AdvancedShow: false,
      search:{
        // contractBeginTime:'',  // 开始时间
        // contractEndTime:'',  // 结束时间
        // cardNum:'', // 银行卡号
        // height:'', // 身高
        // nativePlace:'', // 籍贯，户口所在地搜索
        // birthday:'', // 出生日期
        name:'',// 姓名
        idNum:'',// 身份证号码
        phone:'', // 手机号码
        // workingYears:'',//工龄
        // projectName:'', //项目名称
      },
    };
  },
  methods: {
    // 开始时间选
    hanldeClickDate1(val){
      let c = Number(val.split('-').join(''));
      if(this.search.contractEndTime){
        let d = Number(this.search.contractEndTime.split('-').join(''));
        if(c > d){
           this.$message.warning('开始时间不能大于结束时间')
           this.search.contractBeginTime = ''
           return
        }
      }
      return val
      
    },
     // 结束时间选
    hanldeClickDate2(val){
       let c = Number(val.split('-').join(''));
      if(this.search.contractBeginTime){
         let d = Number(this.search.contractBeginTime.split('-').join(''));
        if(c < d){
           this.$message.warning('结束时间不能小于开始时间')
           this.search.contractEndTime = ''
           return
        }
      }
      return val
    },
    handleSearch(){
      this.$emit('search',this.search)
    },
    // 分类选择功能
    selectValue(val,type) {
      if(type == 'isLong'){
         let isLong =  val.value == "正式员工" ? '0':'1'
         this.search[type] = isLong
      }else{
        this.search[type] = val.value;
      }
      
      this.handleSearch()
    },
    // 打开高级搜索
    hadleSHowGoSearch() {
      this.AdvancedShow = !this.AdvancedShow;
    },
    // checkbox选择
    handleClickCheck(val){
      val.isCheck = !val.isCheck;
      if(val.isCheck){
        if(val.type === 'isIncumbency'){
           this.search[val.type] = val.name=='在职' ?'0' :'1'
        }else{
          this.search[val.type] = val.name
        }

        this.handleSearch()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_search {
  display: flex;
  // margin-bottom: 12px;
  .table_search_item {
    margin-right: 12px;
    .search_item_date {
      width: 150px;
    }
    .search_item_to {
      padding: 0 10px;
    }
    .rotate_top {
      transform: rotate(90deg);
    }
    .rotate_bottom {
      transform: rotate(270deg);
    }
  }
  .table_search_height {
    position: relative;
    span {
      position: absolute;
      right: 5px;
      font-size: 14px;
      color: #c0c4cc;
      transform: translateY(70%);
    }
  }
  .table_search_search {
    margin: 0 16px 0 4px;
    // .table_search_search_btn {
    //   width: 90px;
    //   height: 38px;
    //   padding: 0;
    // }
  }
}
.table_search_class{
  .class_type{
    display: flex;
    div{
      display: inline-block;
    }
  }
  .chekboxGroup{
    margin: 8px 0 0;
    text-align: right;
  }
}
@media screen  and (max-width: 1138px) {
  .table_audited_class{
    display: flex;
    flex-direction: column;
    .chekboxGroup{
      text-align: left;
      margin-top: 12px;
    }
  }
}

@media screen  and (max-width: 919px) {
  .table_tobe_audited_class{
    display: flex;
    flex-direction: column;
    .chekboxGroup{
      text-align: left;
      margin-top: 12px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
<style lang="scss">
.table_search {
  .table_search_item {
    .el-input__inner {
      background: #fcfcfc;
      height: 32px;
      width: 150px;
    }
    .height_input {
      .el-input__inner {
        padding: 0 30px 0 15px;
      }
    }
  }
}
</style>
